import React from "react";
import "./routine-features.css";

export default function WhatUnlocksAfterLaunchSection({ proHref = "/pro" }) {
  return (
    <section className="bs-routine-features" id="what-unlocks" data-testid="what-unlocks-section" aria-labelledby="rf-title">
      <header>
        <p className="rf-eyebrow">BEYOND A SINGLE CHECK</p>
        <h2 id="rf-title" data-testid="what-unlocks-heading">More ways to manage<br className="rf-desktop-break" /> your routine.</h2>
        <p className="rf-intro">Save your products, revisit your checks and bring clearer information to your next appointment.</p>
      </header>
      <div className="rf-main">
        <article className="rf-main-card" data-testid="rf-card-saved-routines">
          <svg className="rf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="4" y="4" width="16" height="17" rx="2" /><path d="M8 2v4m8-4v4M4 10h16" /></svg>
          <span className="rf-pro">Pro feature</span>
          <h3>Saved routines</h3>
          <p>Save your AM and PM routines and revisit your products.</p>
        </article>
        <article className="rf-main-card" data-testid="rf-card-discussion-reports">
          <svg className="rf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M14 2H5v20h14V7zM14 2v6h5M8 12h8M8 16h8" /></svg>
          <span className="rf-pro">Pro feature</span>
          <h3>Discussion reports</h3>
          <p>Download your findings and sources to discuss with a pharmacist or dermatologist.</p>
        </article>
      </div>
      <div className="rf-next">
        <h3 className="rf-next-title">What’s next</h3>
        <p className="rf-next-note">The features below are not available yet.</p>
        <div className="rf-future-grid">
          <article className="rf-future-card" data-testid="rf-card-routine-alerts">
            <svg className="rf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 2 3 6v6c0 6 9 10 9 10s9-4 9-10V6zM12 7v6m0 3v1" /></svg>
            <div>
              <div className="rf-row"><h4>Routine update alerts</h4><span className="rf-status">Not available yet</span></div>
              <p>Receive an email when changes to reviewed information affect your saved routines.</p>
            </div>
          </article>
          <article className="rf-future-card" data-testid="rf-card-routine-digest">
            <svg className="rf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2" /><path d="m2 5 10 8L22 5" /></svg>
            <div>
              <div className="rf-row"><h4>Personal routine digest</h4><span className="rf-status">Not available yet</span></div>
              <p>A periodic summary of changes affecting your saved routines and relevant reviewed findings.</p>
            </div>
          </article>
          <article className="rf-future-card" data-testid="rf-card-ai-builder">
            <svg className="rf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m3 21 13-13m-3-3 6 6M5 2v6M2 5h6m11-4v6m-3-3h6" /></svg>
            <div>
              <div className="rf-row"><h4>AI routine builder</h4><span className="rf-status">Planned</span></div>
              <p>Help creating a routine around your products and preferences.</p>
            </div>
          </article>
          <article className="rf-future-card" data-testid="rf-card-skin-preferences">
            <svg className="rf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 6h18M3 12h18M3 18h18" /><circle cx="8" cy="6" r="2" /><circle cx="16" cy="12" r="2" /><circle cx="9" cy="18" r="2" /></svg>
            <div>
              <div className="rf-row"><h4>Personalized skin preferences</h4><span className="rf-status">Planned</span></div>
              <p>Account for your skin preferences when reviewing your routine.</p>
            </div>
          </article>
        </div>
      </div>
      <aside className="rf-shared" data-testid="rf-shared-scanning">
        <svg className="rf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 8V3h5m8 0h5v5m0 8v5h-5M8 21H3v-5M7 8v8m3-8v8m4-8v8m3-8v8" /></svg>
        <div>
          <h3>Product scanning <span>Shared feature</span></h3>
          <p>Scan a product label or barcode to look up ingredients. Scanning limits are currently the same for Free and Pro.</p>
        </div>
      </aside>
      <footer>
        <p>Single checks remain free. See plan details for feature access.</p>
        <a className="rf-cta" href={proHref} data-testid="what-unlocks-cta">Explore Pro <span aria-hidden="true">→</span></a>
      </footer>
    </section>
  );
}
